import React from 'react';
import { motion } from 'framer-motion';
import { CoinsIcon, ArrowUpIcon } from 'lucide-react';
import { GlassCard } from './GlassCard';
import { goldRates } from '../data/bankData';
const rows = [{
  label: '24K',
  data: goldRates.k24
}, {
  label: '22K',
  data: goldRates.k22
}, {
  label: '21K',
  data: goldRates.k21
}];
export function GoldRates() {
  return <GlassCard delay={0.25} className="p-4 flex flex-col" data-id="element-89">
      <div className="flex items-center justify-between mb-3" data-id="element-90">
        <div className="flex items-center gap-2.5" data-id="element-91">
          <div className="flex items-center justify-center h-9 w-9 rounded-lg bg-amber-500 border border-white/15" data-id="element-92">
            <CoinsIcon className="h-4.5 w-4.5 text-white" data-id="element-93" />
          </div>
          <div data-id="element-94">
            <div className="text-[10px] uppercase text-white/70 font-semibold" data-id="element-95">
              Precious Metals
            </div>
            <div className="tracking-display text-lg font-bold text-white leading-tight" data-id="element-96">
              Gold Rates
            </div>
          </div>
        </div>
        <div className="text-[10px] uppercase text-white/65 font-semibold" data-id="element-97">
          LKR · Today
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2.5 flex-1" data-id="element-98">
        {rows.map((r, i) => <motion.div key={r.label} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3 + i * 0.08
      }} className="rounded-lg p-3 flex flex-col justify-between" style={{
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.08)'
      }} data-id="element-99">
            <div className="flex items-center justify-between" data-id="element-100">
              <span className="tracking-display text-xl font-extrabold text-amber-300" data-id="element-101">
                {r.label}
              </span>
              <span className="flex items-center gap-0.5 text-[11px] font-bold text-[#9ed957]" data-id="element-102">
                <ArrowUpIcon className="h-3.5 w-3.5" data-id="element-103" />
                {r.data.change}%
              </span>
            </div>
            <div className="mt-2" data-id="element-104">
              <div className="text-[10px] uppercase text-white/55 font-semibold" data-id="element-105">
                Per Gram
              </div>
              <div className="font-mono-num text-base font-bold text-white leading-tight" data-id="element-106">
                {r.data.perGram.toLocaleString()}
              </div>
            </div>
            <div className="mt-1.5" data-id="element-107">
              <div className="text-[10px] uppercase text-white/55 font-semibold" data-id="element-108">
                Sovereign
              </div>
              <div className="font-mono-num text-sm font-bold text-white/90 leading-tight" data-id="element-109">
                {r.data.perSovereign.toLocaleString()}
              </div>
            </div>
          </motion.div>)}
      </div>
    </GlassCard>;
}